import Vue from 'vue'
import App from './App.vue'
// 引入ELEMENT
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css'

import './assets/iconfont/iconfont.css'

import './assets/common.css'

// 引入FILTER
import filters from '../src/utils/filter'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 引入全局配置
import config from '../src/utils/config'
Vue.prototype.$config = config.data

Vue.config.productionTip = false

import router from './router'
import store from './store'
router.beforeEach((to, from, next) => {
  document.title = (to.meta.title ? to.meta.title + '-' : '') + '众联馨'
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')